// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/DevicesPage/styles.scss
// module id = 1107
// module chunks = 0